import i18next from 'i18next'
import { now } from '../../../../../config/dayjsConfig'
import {
  DailyDelivery,
  DeliverySubscription,
  ManualDelivery,
  MonthlyDelivery,
  PeriodLockDelivery,
  WeeklyDelivery
} from '../../../../../types/deliverySubscription/DeliverySubscription'

export const renderDeliverySubscriptionInitiator = (deliverySubscription: DeliverySubscription) => {
  const { initiator } = deliverySubscription
  if ((initiator as MonthlyDelivery)?.monthly as { day: number }) {
    const { day } = (initiator as MonthlyDelivery).monthly as { day: number }
    return i18next.t('subscriptionsPage:iMonthly', { day })
  }
  if ((initiator as WeeklyDelivery)?.weekly as { dow: number }) {
    const { dow } = (initiator as WeeklyDelivery).weekly as { dow: number }
    return `${i18next.t('global:every')} ${now().day(dow).format('dddd')}`
  }
  if ((initiator as DailyDelivery)?.daily) {
    return i18next.t('subscriptionsPage:daily')
  }
  const { periodLock } = (initiator as PeriodLockDelivery) || {}
  if (periodLock === true || (periodLock as unknown) === 'true') {
    return i18next.t('subscriptionsPage:periodLock')
  }
  if ((initiator as ManualDelivery)?.manual) {
    return i18next.t('subscriptionsPage:manual')
  }
  return null
}
